import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ModelsProvider } from '../../providers/models/models';
import { EditorPage } from '../editor/editor';

/**
 * Generated class for the LayoutPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-models',
  templateUrl: 'models.html',
})
export class ModelsPage {
  project:any;
  models:any;
  layout_type:any;
  layout_index:any;
  selected:any = null;
  constructor(
    private modelsProvider: ModelsProvider,
    public navCtrl: NavController,
    public navParams: NavParams
  ) {
    this.project = this.navParams.get('project');
    this.layout_type = this.navParams.get('layout_type');
    this.layout_index = this.navParams.get('layout_index');
  }

  selectScreenshot(i){
    this.selected = i;
  }


  ionViewDidLoad() {
    // console.log("this.layout_type",this.layout_type);
    this.models = this.modelsProvider.getModels(this.layout_type);
    // console.log("this.models",this.models);
    // console.log('ionViewDidLoad ModelsPage');
  }

  goToEditor(){
    this.navCtrl.push(EditorPage,{project:this.project, layout_type: this.layout_type,layout_index: this.layout_index, model_index: this.selected});
  }

}



// WEBPACK FOOTER //
// ./src/pages/models/models.ts